import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { useFlowTestInterpretations } from "../../../hooks/FlowTest";
import FlowTestInterpretations from "../FlowTestInterpretations/FlowTestInterpretations";

interface InterpretationsTabProps {
  flowTestId: string;
  captureId: number;
  entityId: number;
  handleError: (error: any) => void;
  canEdit: boolean;
}

const InterpretationsTab: React.FC<InterpretationsTabProps> = ({ flowTestId, captureId, entityId, handleError, canEdit }) => {
  const { 
    interpretationsData, 
    isPending, 
    createInterpretation, 
    updateInterpretation, 
    deleteInterpretation,
    refetch
  } = useFlowTestInterpretations(flowTestId);

  if (isPending && interpretationsData.length === 0) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <FlowTestInterpretations
      flowTestId={Number(flowTestId)}
      captureId={captureId}
      entityId={entityId}
      interpretationsData={interpretationsData}
      canEdit={canEdit}
      onCreate={async (values) => {
        await createInterpretation(values).catch(handleError);
      }}
      onUpdate={async (id, values) => {
        await updateInterpretation({ interpretationId: id, values }).catch(handleError);
      }}
      onDelete={async (id) => {
        await deleteInterpretation(id).catch(handleError);
      }}
      onRequestRefresh={refetch}
    />
  );
};

export default InterpretationsTab;
